import { Router } from '@angular/router';
import { Injectable } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';
import { Network } from '@capacitor/network';

import { ModalDownloadComponent } from './modal-download/modal-download.component';
import { getUrl } from '../../../../../core/store/selectors/router.selectors';
import { cancelDownloading } from '../../../../../core/store/actions/offline.actions';
import { Delivery } from '../../../../../core/models';
import * as fromRoot from '../../../../../core/store';

@Injectable({ providedIn: 'root' })
export class DownloadBtnService {
  private modalWindow;

  constructor(
    public modalController: ModalController,
    private store: Store<any>,
    private router: Router,
  ) {
    this.onDisconnectListen();
  }

  showWifiWarning(delivery) {
    const modalData: { [key: string]: string } = {};

    modalData.modalTitle = 'Connection problem';
    modalData.modalText = 'Device not connected to WiFi, Please connect to a WiFi network.';
    this.showDownloadModal(modalData, delivery, 'other');
  }

  showCancelDownloadModal(delivery) {
    const modalData: { [key: string]: string } = {};

    modalData.modalTitle = 'Cancel Offline Item Download';
    modalData.modalText = 'Do you want to cancel this download in progress?';
    modalData.modalOkButton = 'Stop Download';
    this.showDownloadModal(modalData, delivery, 'cancelDownloading');
  }

  showRemoveDownloadedModal(delivery) {
    const modalData: { [key: string]: string } = {};

    modalData.modalTitle = 'Clear Offline Item';
    modalData.modalText = 'Do you want to remove this offline item from your device?';
    modalData.modalOkButton = 'Clear Item';
    this.showDownloadModal(modalData, delivery, 'removeDelivery');
  }

  showLimitDownloadWindow(delivery) {
    const modalData: { [key: string]: string } = {};

    modalData.modalTitle = 'Offline playback is turned off';
    modalData.modalText = 'Please enable Offline Playback from the Application Settings.';
    modalData.modalOkButton = '';
    this.showDownloadModal(modalData, delivery, 'cancelDownloading');
  }

  private async showDownloadModal(
    modalData,
    delivery: Delivery,
    modalType: 'cancelDownloading' | 'removeDelivery' | 'other',
  ) {
    this.modalWindow = await this.modalController.create({
      component: ModalDownloadComponent,
      cssClass: 'modal-delivery-download',
      componentProps: modalData,
    });

    if (modalType === 'cancelDownloading') {
      this.modalWindow
        .onDidDismiss()
        .then((resp: any) => this.onCancelDismissBtnClick(resp, delivery));
    } else if (modalType === 'removeDelivery') {
      this.modalWindow
        .onDidDismiss()
        .then((resp: any) => this.onRemoveDismissBtnClick(resp, delivery));
    }

    await this.modalWindow.present();
  }

  private onRemoveDismissBtnClick(resp, delivery): void {
    if (resp && resp.data && resp.data.status === 'ok') {
      this.store.dispatch(
        fromRoot.removeOfflineDelivery({
          deliveryKeyCode: delivery.deliveryKeyCode,
        }),
      );

      this.store.pipe(select(getUrl), take(1)).subscribe((url: string) => {
        if (!url.includes('inbox')) {
          this.router.navigate(['/offline']);
        }
      });
    }
  }

  private onCancelDismissBtnClick(resp, delivery): void {
    if (resp && resp.data && resp.data.status === 'ok') {
      this.store.dispatch(
        cancelDownloading({
          deliveryKeyCode: delivery.deliveryKeyCode,
        }),
      );
    }
  }

  private onDisconnectListen(): void {
    Network.addListener('networkStatusChange', ({ connected }) => {
      if (!connected && this.modalWindow) {
        this.modalWindow.dismiss();
      }
    });
  }
}
